import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URLS, PLATFORM_TYPE } from '../constants/constants'
import { parseJwt } from '../components/utilities/utils'
import { Header } from '../ui';

export const epbAndPinService = createApi({
  reducerPath: 'epbAndPinService',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.BALLOT_BASE_URL ,
  prepareHeaders: (headers) => {
    headers.set("authorization", `Bearer ${localStorage.access_token}`);
    headers.set("currentRole", localStorage.userrole);
    headers.set("constNo", parseJwt(localStorage.access_token)?.authorizedPcs?.[0]);
    headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
    return headers;
  },}),
  endpoints: (builder) => ({
    downloadEpbPin: builder.mutation({
      query: (data) => ({
        url: 'api/v1/epb-data/download-pin',
        method: 'Post',
        body: data,
        responseHandler: (response) => response.blob(),
        headers: {
          'Content-type': 'application/json',
          'constType': data.constType,
        },
      }),
    }),
    downloadEpb: builder.mutation({
      query: (data) => ({
        url: '/api/v1/epb-data/download-epb',
        method: 'Post',
        body: data,
        responseHandler: (response) => response.blob(),
        headers: {
          'Content-Type': 'application/json',
          'constType': data.constType,
        },
      }),
    }),
    verifyBallot: builder.mutation({
      
      query: (data) => ({
        url: '/api/v1/epb-data/verify-ballot',
        method: 'Post',
        body: data?.file,
        headers: {
          verficationFlag:data?.verificationFlag
        },
      }),
    }),
    createBallot: builder.mutation({
      query: (data) => ({
        url: `/api/v1/epb-data/create-ballot?path=${data.constType}`,
        method: 'Post',
        body: data.ballotRecords,
        responseHandler: (response) => response.blob(),
        headers: {
          'Content-Type': 'application/json',
          'lang':data.lang,
          'constType':data.constType
        },
      }),
    }),
  }),
})
export const {
  useDownloadEpbMutation,
  useDownloadEpbPinMutation,
  useVerifyBallotMutation,
  useCreateBallotMutation
  
} = epbAndPinService
